<template>
  <tr class="bg-row">
    <td @click="$emit('toggle', item)">
      <v-icon>{{ isRowExpanded ? "mdi-minus" : "mdi-plus" }}</v-icon>
    </td>
    <td></td>
    <td colspan="10" class="client-name">{{ item.client_name }}</td>
  </tr>
</template>

<script>
export default {
  props: {
    item: Object,
    isRowExpanded: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped>
.bg-row {
  background-color: #c4e0e8;
}
.client-name {
  font-weight: bold;
}
</style>
